import axios from "axios";
import axiosInstance from "api/axiosInstance";
import { toast } from "react-toastify";

export const getWobList = async (accessToken) => {
  try {
    const response = await axiosInstance.get(
      "/business/@me/access-list",
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("getWobList error:", error);

    throw error;
  }
};
export const addAccessListPhone = async (data, accessToken) => {
  try {
    const response = await axiosInstance.post(
      "/business/@me/access-list",
      data,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    if (error.response) {
      const errorMessage =
        error.response.data?.error ||
        error.response.data?.detail ||
        error.message;

      // if (errorMessage) {
      //   toast.error(errorMessage);
      // } else {
      //   toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      // }
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }

    throw error; // خیلی مهم
  }
};
export const changeListType = async (payload, accessToken) => {
  try {

    const response = await axiosInstance.patch(
      "/business/@me/privacy",
      payload,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return response.data;

  } catch (error) {
    if (error.response) {
      const errorMessage =
        error.response.data?.error ||
        error.response.data?.detail ||
        error.message;

      // if (errorMessage) {
      //   toast.error(errorMessage);
      // } else {
      //   toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
      // }
    } else {
      toast.error("مشکل شبکه یا عدم دسترسی به سرور.");
    }

    throw error; // خیلی مهم
  }
};
export const deleteAccessListPhone = async (entryId, accessToken) => {
  try {
    const response = await axiosInstance.delete(
      `/business/@me/access-list/${entryId}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return {
      ok: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    console.error(
      "❌ Error deleting access list phone:",
      error
    );

    if (error.response) {
      return {
        ok: false,
        status: error.response.status,
        error:
          error.response.data?.error ||
          error.response.data?.message ||
          "خطایی در حذف شماره رخ داد",
      };
    }

    if (error.request) {
      return {
        ok: false,
        status: null,
        error: "ارتباط با سرور برقرار نشد",
      };
    }

    return {
      ok: false,
      status: null,
      error: error.message || "خطای ناشناخته‌ای رخ داد",
    };
  }
};
export const getAccessListChatrooms = async (entryId, accessToken) => {
  try {
    const response = await axiosInstance.get(
      `/business/@me/access-list/${entryId}/chatrooms`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );

    return {
      ok: true,
      data: response.data,
      status: response.status,
    };

  } catch (error) {
    console.error(
      "❌ Error getting access list chatrooms:",
      error
    );

    if (error.response) {
      return {
        ok: false,
        status: error.response.status,
        error:
          error.response.data?.error ||
          error.response.data?.message ||
          "خطایی در دریافت گفتگوها رخ داد",
      };
    }

    if (error.request) {
      return {
        ok: false,
        status: null,
        error: "ارتباط با سرور برقرار نشد",
      };
    }

    return {
      ok: false,
      status: null,
      error: error.message || "خطای ناشناخته‌ای رخ داد",
    };
  }
};